import { useMemo } from 'react';
import useResourceGroupOptions from './useResourceGroupOptions';

/** Each resource of a pool-backed group by id, with what a guest may know of it ("Electric · Large"). */
const useResourceGroupAttributeLabels = ({
  experienceIds,
  resourceGroupId,
}: {
  experienceIds: string[];
  resourceGroupId?: string;
}) => {
  const { data } = useResourceGroupOptions({ experienceIds, resourceGroupId });

  return useMemo(
    () =>
      new Map(
        (data?.resources ?? [])
          .filter((resource) => resource.attributes.length > 0)
          .map((resource) => [
            resource.experienceId,
            resource.attributes.map((attribute) => attribute.label).join(' · '),
          ]),
      ),
    [data],
  );
};

export default useResourceGroupAttributeLabels;
